/**
 * Cerbos resource kind identifiers for the Balances domain.
 * Mirrors the backend WS command names used as resource kinds.
 */
export enum BalanceCommands {
  Balances = 'Balances',
  CloseSmallTokens = 'CloseSmallTokens',
  AddBalance = 'AddBalance',
}

/**
 * Balance-history resource kind identifiers used in Cerbos authz checks.
 * Values match the backend WS command strings for these resources.
 */
export enum BalanceHistoryCommands {
  BalanceHistory = 'BalanceHistory',
  PriceHistory = 'PricesHistory',
  SetInitialBalance = 'SetInitialBalance',
  ResetInitialBalance = 'ResetInitialBalance',
}

/**
 * Account-domain resource kind identifiers used in balance authz checks.
 * Mirrors AccountCommands from the accounts store; will be replaced by a direct
 * import from @skynet/data-accounts once that package is extracted.
 */
export enum AccountCommands {
  DisableAccount = 'DisableAccount',
}

/** Union of all Cerbos resource kinds relevant to the Balances domain. */
export type BalanceResource =
  | `${BalanceCommands}`
  | `${BalanceHistoryCommands}`
  | `${AccountCommands}`;

/**
 * Narrow set of Cerbos actions valid for balance resources.
 * Values align with the standard Cerbos action strings.
 */
export const BalanceActions = {
  Read: 'read',
  Create: 'create',
  Update: 'update',
  Delete: 'delete',
} as const;

export type BalanceActionType = (typeof BalanceActions)[keyof typeof BalanceActions];
